import React from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { MdCached } from "react-icons/md";
import NotificationsVolume from "../NotificationsVolume";
import NotificationsPopOver from "../NotificationsPopOver";
import ChatPopover from "../../pages/Chat/ChatPopover";
import VersionControl from "../VersionControl";
import DarkMode from "../DarkMode";
import AiStatusCard from "../AiStatusCard";
import CompanySwitcher from "../CompanySwitcher";
import { i18n } from "../../translate/i18n";

const iconControlClass =
  "flex h-[38px] w-[38px] min-w-[38px] items-center justify-center overflow-visible rounded-[10px] border border-farmazon-border bg-[var(--farmazon-surface)] text-farmazon-text-muted shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-colors duration-[180ms] ease-in-out hover:bg-farmazon-hover dark:border-white/[0.08] dark:hover:border-white/[0.14]";

const HeaderTooltip = ({ title, children }) => (
  <span className="group/header-tooltip relative inline-flex cursor-pointer">
    {children}
    <span className="pointer-events-none absolute left-1/2 top-full z-[1400] mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-[#616161] px-2 py-1 text-[11px] font-medium text-white shadow-md group-hover/header-tooltip:block">
      {title}
    </span>
  </span>
);

const LayoutHeader = ({
  hideMenu,
  drawerOpen,
  leftMode = "push",
  user,
  onRefresh,
  volume,
  onChangeVolume,
  onUpdateStart,
  onUpdateComplete,
  waitingCount,
}) => {
  const { pathname } = useLocation();
  const hasRightRail = /^\/tickets\/[^/]+/i.test(pathname);
  const menuPushesContent = leftMode === "push" && drawerOpen;

  return (
    <header
      className={clsx(
        "fixed top-0 left-0 right-0 z-[1201] h-16 flex items-center bg-farmazon-bg border-b border-farmazon-border transition-all duration-300 ease-in-out",
        !hideMenu && !menuPushesContent && "ml-16",
        !hideMenu && menuPushesContent && "ml-[270px]",
        hideMenu && "ml-0",
        hasRightRail && "mr-16",
      )}
    >
      <div className="flex items-center justify-between w-full h-full px-4 gap-1">
        <div className="flex items-center gap-2 flex-shrink-0">
          <AiStatusCard waitingCount={waitingCount} className="mt-1 w-[340px]" />
          <CompanySwitcher user={user} className="mt-1 w-auto" />
        </div>
        {!hideMenu && (
          <div className="flex items-center gap-1.5 mr-16">
            <VersionControl
              onUpdateStart={onUpdateStart}
              onUpdateComplete={onUpdateComplete}
            />

            <HeaderTooltip title={i18n.t("mainDrawer.appBar.volume", "Volume")}>
              <span className={clsx(iconControlClass, "cursor-pointer")}>
                <NotificationsVolume
                  setVolume={onChangeVolume}
                  volume={volume}
                />
              </span>
            </HeaderTooltip>

            <HeaderTooltip
              title={i18n.t("mainDrawer.appBar.refresh", "Atualizar")}
            >
              <span className={clsx(iconControlClass, "cursor-pointer")}>
                <button
                  type="button"
                  onClick={onRefresh}
                  aria-label={i18n.t("mainDrawer.appBar.refresh")}
                  className="flex h-full w-full cursor-pointer items-center justify-center rounded-[10px] border-0 bg-transparent p-0 text-inherit outline-none transition-colors"
                >
                  <MdCached className="!text-xl" />
                </button>
              </span>
            </HeaderTooltip>

            {user.id && (
              <HeaderTooltip
                title={i18n.t(
                  "mainDrawer.appBar.notifications",
                  "Atendimento",
                )}
              >
                <span className={clsx(iconControlClass, "cursor-pointer")}>
                  <NotificationsPopOver volume={volume} />
                </span>
              </HeaderTooltip>
            )}

            <HeaderTooltip
              title={i18n.t("mainDrawer.listItems.chats", "Chat interno")}
            >
              <span className={clsx(iconControlClass, "cursor-pointer")}>
                <ChatPopover />
              </span>
            </HeaderTooltip>

            <HeaderTooltip title="Alternar tema">
              <span className={clsx(iconControlClass, "cursor-pointer")}>
                <DarkMode />
              </span>
            </HeaderTooltip>

          </div>
        )}
      </div>
    </header>
  );
};

export default LayoutHeader;
